import { render, staticRenderFns } from "./pi-button-select.vue?vue&type=template&id=34d039d2&scoped=true&"
import script from "./pi-button-select.vue?vue&type=script&lang=ts&"
export * from "./pi-button-select.vue?vue&type=script&lang=ts&"
import style0 from "./pi-button-select.vue?vue&type=style&index=0&id=34d039d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d039d2",
  null
  
)

export default component.exports